<template>
  <div>
    <div class="aprtmentImagesConatiner">
      <div
        v-for="(image, index) in firstFiveImages"
        :key="index"
        class="aprtmentImageWrapper"
        :style="{
          opacity: mouseOnImage === null || mouseOnImage === index ? 1 : 0.5,
        }"
        @mouseover="mouseOnImage = index"
        @mouseout="mouseOnImage = null"
        @click="openModal(index)"
      >
        <img :src="image.url" alt="" />
      </div>
    </div>

    <div class="ShowResAprtmentImages">
      <Swiper
        class="ShowResAprtmentImagesConatiner1"
        :slides-per-view="1"
        :pagination="{ dynamicBullets: true }"
        :modules="modules"
      >
        <SwiperSlide v-for="(image, index) in allImages" :key="index">
          <div class="ShowResAprtmentImagesConatiner" @click="openModal(index)">
            <img :src="image.url" alt="" />
          </div>
        </SwiperSlide>
      </Swiper>

      <div class="postInfoContainer">
        <div class="postInfoList">
          <div class="infoThumb" :class="{ disabled: likeLoading }">
            <VsxIcon
              @click="saveLike(data.id)"
              iconName="Heart"
              :size="30"
              :color="data.is_like == 1 ? '#212121' : '#f00'"
              :type="data.is_like == 1 ? 'linear' : 'bold'"
              :class="{ liked: data.is_like == 2 }"
            />
            <span class="infoNum">{{ data.likes }}</span>
          </div>
          <div class="infoThumb" @click="showComments">
            <VsxIcon
              iconName="Message"
              :size="30"
              color="#212121"
              type="linear"
            />
            <span class="infoNum">{{ comment_count }}</span>
          </div>
          <div class="infoThumb" @click="contentShare">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
              />
            </svg>
          </div>
        </div>
        <div class="postInfoList">
          <div class="infoThumb" @click="saveFavorite(data.id)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              :fill="data.is_favorite == 1 ? 'none' : '#000'"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#000"
              :class="{ saved: data.is_favorite == 2 }"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <transition name="modal">
      <div v-if="showModal" class="imagesModalContainer">
        <div class="modalTopnav">
          <div class="topNavContainer">
            <div class="topNavComlumn">
              <div class="modalCloseBtn" @click="closeModal">
                <i class="fa-solid fa-xmark"></i>
              </div>
              <div class="propertyInfoWrapper">
                <h2 class="propertyTitle">{{ data.content }}</h2>
              </div>
            </div>
            <div class="topNavComlumn">
              <div class="modalButtonWrapper" @click="contentShare">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                  />
                </svg>
                <div class="btnDivider"></div>
                <div class="buttonTitle">اشتراک گذاری</div>
              </div>

              <div class="modalButtonWrapper" @click="saveLike(data.id)">
                <VsxIcon
                  iconName="Heart"
                  :size="28"
                  :color="data.is_like == 2 ? '#f00' : '#212121'"
                  :type="data.is_like == 2 ? 'bold' : 'linear'"
                />
                <div class="btnDivider"></div>
                <div class="buttonTitle">مورد علاقه‌</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modalMainSlider">
          <div class="mainSliderContainer">
            <Swiper
              :slides-per-view="1"
              :navigation="true"
              :thumbs="{ swiper: thumbsSwiper }"
              :modules="modules"
              @slideChange="onSlideChange"
              @swiper="setSwiperInstance"
            >
              <SwiperSlide v-for="(image, index) in allImages" :key="index">
                <div class="mainImagesWrapper">
                  <img :src="image.url" alt="" class="mainImage" />
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>

        <div class="modalPaginationSlider">
          <div class="modalPaginationContainer">
            <div class="customPagination">
              {{ currentSlide }} / {{ totalSlide }}
            </div>

            <Swiper
              @swiper="setThumbsSwiper"
              :slides-per-view="'auto'"
              :space-between="10"
              :free-mode="true"
              :watch-slides-progress="true"
              :modules="modules"
              class="thumbSwiper"
            >
              <SwiperSlide v-for="(image, index) in allImages" :key="index">
                <div class="miniImageWrapper">
                  <img :src="image.url" alt="" class="miniImage" />
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </transition>

    <LoginUser @close="ShowLoginBoxes = false" v-if="ShowLoginBoxes" />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import { nextTick } from "vue";
import "swiper/swiper-bundle.css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    comment_count: {
      type: [String, Number],
      default: 0,
    },
    contentShare: {
      type: Function,
      required: true,
    },
    saveFavorite: {
      type: Function,
      required: true,
    },
    saveLike: {
      type: Function,
      required: true,
    },
    showComments: {
      type: Function,
      required: true,
    },
    likeLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modules: [FreeMode, Navigation, Thumbs, Pagination],
      mouseOnImage: null,
      thumbsSwiper: null,
      swiperInstance: null,
      currentSlide: 1,
    };
  },
  computed: {
    totalSlide() {
      return this.allImages.length;
    },
    allImages() {
      const photos = this.data?.photo_galleries_mobile || [];
      return this.data?.avatar
        ? [{ url: this.data.avatar }, ...photos]
        : photos;
    },
    desktopAllImages() {
      const photos = this.data?.photo_galleries || [];
      return this.data?.avatar
        ? [{ url: this.data.avatar }, ...photos]
        : photos;
    },
    firstFiveImages() {
      return this.desktopAllImages.slice(0, 5);
    },
    showModal() {
      return this.$route.query.images === "active";
    },
  },
  watch: {
    showModal(newVal) {
      if (!newVal) {
        this.resetModal();
      }
    },
  },
  methods: {
    async openModal(index) {
      this.$router.push({
        query: {
          ...this.$route.query,
          images: "active",
        },
      });

      await nextTick();

      const goToSlide = () => {
        if (this.swiperInstance) {
          this.swiperInstance.slideTo(index, 0);
          this.currentSlide = index + 1;
        } else {
          setTimeout(goToSlide, 50);
        }
      };

      goToSlide();

      document.body.style.overflow = "hidden";
    },
    closeModal() {
      history.back();
    },
    resetModal() {
      this.swiperInstance = null;
      this.thumbsSwiper = null;
      this.currentSlide = 1;
      document.body.style.overflow = "auto";
    },
    onSlideChange(swiper) {
      this.currentSlide = swiper.realIndex + 1;
    },
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper;
    },
    setSwiperInstance(swiper) {
      this.swiperInstance = swiper;
    },
  },
  beforeUnmount() {
    this.resetModal();
  },
};
</script>

<style lang="scss" scoped>
.carousel__pagination {
  bottom: 0 !important;
}

.carousel__pagination-button {
  padding: 0 !important;
}

.carousel__pagination-button::after {
  height: 6px;
  width: 6px;
  border-radius: 100%;
  margin-top: 10px !important;
  background: rgba(0, 166, 147, 0.4);
}

.ShowResAprtmentImages {
  position: relative;

  .postInfoContainer {
    display: none;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: flex-start;
    padding: 24px 0 0;
    width: 90%;
    margin: 0 auto;

    .postInfoList {
      display: flex;
      flex-direction: row-reverse;
      gap: 16px;
    }

    .infoThumb {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #212121;
      font-size: 13px;
      cursor: pointer;

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }

      i {
        padding-top: 4px;
        font-size: 26px;
      }

      .infoNum {
        font-size: 12px;
        margin-top: 4px;
      }
    }
  }
}

.imagesModalContainer {
  position: relative;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 9999;
  overflow-y: auto;
  overflow-x: hidden;

  .modalCloseBtn {
    flex-shrink: 0;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #fff;
    background: #0096c7;
    border-radius: 0.6875rem;
    border: 1px solid #0096c7;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    z-index: 99;
  }

  .modalTopnav {
    width: 100%;
    padding: 36px 0 24px;
    color: #000;

    .topNavContainer {
      width: 90%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .topNavComlumn {
        display: flex;
        align-items: center;

        .propertyInfoWrapper {
          margin-right: 16px;

          .propertyTitle {
            font-family: "iranyekan", sans-serif;
            font-size: 16px;
            color: #131b1f;
            margin-bottom: -2px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .propertyOwner {
            font-family: "iranyekanL", sans-serif;
            font-size: 14px;
            font-weight: 300;
            color: #131b1f;
          }
        }

        .modalButtonWrapper {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 45px;
          padding: 10px 15px;
          border-radius: 10px;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);
          border: 1px solid #ddd;
          background-color: transparent;
          color: #242424;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;

          .btnDivider {
            margin-right: 13px;
            margin-left: 11px;
            width: 1px;
            height: 100%;
            background-color: #ddd;
          }

          &:first-of-type {
            margin-left: 16px;
          }

          .buttonTitle {
            white-space: nowrap;
          }
        }
      }
    }
  }

  .modalMainSlider {
    width: 100%;
    height: calc(100% - 150px - 105px);

    .mainSliderContainer {
      position: relative;
      width: 90%;
      height: 100%;
      margin: 0 auto;

      .swiper {
        height: 100%;

        :deep(.swiper-button-prev),
        :deep(.swiper-button-next) {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 45px;
          height: 45px;
          border-radius: 0.6875rem;
          border: 1px solid #0096c7;
          background: #0096c7;
          transition: all 0.075s ease-in-out;

          &:active {
            transform: scale(0.95);
          }

          &::after {
            font-size: 20px;
            font-weight: 700;
            color: #fff;
          }
        }
      }

      .mainImagesWrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        .mainImage {
          display: block;
          max-width: 76%;
          max-height: 90%;
          object-fit: contain;
          border-radius: 8px;
          overflow: hidden;
        }
      }
    }
  }

  .modalPaginationSlider {
    width: 100%;
    height: 150px;

    .modalPaginationContainer {
      width: 90%;
      height: 100%;
      margin: 0 auto;

      .customPagination {
        color: #131b1f;
        margin-right: 8px;
        margin-bottom: 0.25rem;
        font-size: 14px;
        font-weight: 400;
      }

      .swiper {
        .swiper-slide {
          width: auto;
        }

        .swiper-slide-thumb-active {
          .miniImageWrapper {
            &::before {
              display: block;
            }
          }
        }
      }

      .miniImageWrapper {
        position: relative;
        margin-left: 0.625rem;

        &::before {
          content: "";
          display: none;
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          border-radius: 0.625rem;
          border: 3px solid #0096c7;
          z-index: 2;
        }

        .miniImage {
          position: relative;
          width: 182px;
          height: 114px;
          object-fit: cover;
          border-radius: 0.625rem;
          z-index: 1;
          cursor: pointer;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .ShowResAprtmentImages {
    .postInfoContainer {
      display: flex;
    }
  }
}

@media (max-width: 600px) {
  .imagesModalContainer {
    .modalCloseBtn {
      background: transparent;
      box-shadow: none;
      border: none;
      border-radius: 0;
      font-size: 22px;
      color: #242424;
    }

    .modalTopnav {
      padding-top: 12px;
      padding-bottom: 24px;
      .topNavContainer {
        .topNavComlumn {
          .modalButtonWrapper {
            border: none;
            border-radius: 0;
            box-shadow: none;

            &:first-of-type {
              margin: 0;
            }

            svg {
              width: 20px;
              height: 20px;
            }

            .btnDivider,
            .buttonTitle {
              display: none;
            }
          }
        }
      }
    }

    .modalMainSlider {
      height: calc(100% - 222.8px);
      .mainSliderContainer {
        width: 100%;
        .swiper {
          :deep(.swiper-button-prev),
          :deep(.swiper-button-next) {
            display: none;
          }
        }

        .mainImagesWrapper {
          .mainImage {
            max-width: 100%;
            border-radius: 0;
          }
        }
      }
    }

    .modalPaginationSlider {
      height: 136px;
      .modalPaginationContainer {
        width: 100%;
        .swiper {
          .swiper-slide-thumb-active {
            .miniImageWrapper {
              margin: 0 0.7rem;
              &::before {
                display: none;
              }

              .miniImage {
                opacity: 1;
              }
            }
          }
        }

        .miniImageWrapper {
          margin: 0;
          transition: all 0.15;

          .miniImage {
            width: 86px;
            height: 86px;
            border-radius: 0;
            opacity: 0.75;
          }
        }
      }
    }
  }
}
</style>
